export default __webpack_public_path__ + "static/media/block_monitor.1649dae3.png";